<dx-chart class="me-2"
          [ngClass]="{ compact: displayCompact }"
          [dataSource]="chartData"
          [rotated]="true"
          [barGroupPadding]="0.5"
          [customizePoint]="customizeChartPoint"
          (onDone)="updateChartDimensionAndSubscribeSizeChange($event)">
    <dxo-chart-animation [enabled]="false"></dxo-chart-animation>
    <dxo-chart-common-series-settings argumentField="responseGroup"
                                      valueField="value"
                                      [barPadding]="0.1"
                                      type="bar">
        <dxo-chart-common-series-settings-label [visible]="true"
                                                position="inside"
                                                [horizontalOffset]="-2000"
                                                backgroundColor="transparent"
                                                [customizeText]="customizeSeriesLabel"></dxo-chart-common-series-settings-label>
    </dxo-chart-common-series-settings>
    <dxo-chart-argument-axis [inverted]="true">
        <dxo-chart-label [customizeText]="customizeArgumentLabel"></dxo-chart-label>
    </dxo-chart-argument-axis>
    <dxi-chart-value-axis [valueMarginsEnabled]="false"
                          [showZero]="true"
                          [visualRange]="[0, 100]"
                          visualRangeUpdateMode="keep">
        <dxo-chart-grid [visible]="true"></dxo-chart-grid>
        <dxo-chart-label [customizeText]="pointToPercentage"></dxo-chart-label>
    </dxi-chart-value-axis>

    <dxo-chart-series-template nameField="valueType"></dxo-chart-series-template>
    <dxo-chart-legend [visible]="false"></dxo-chart-legend>
</dx-chart>
